import React from "react";

/**
 * Brand-inspired minimalist mountain silhouette.
 *
 * Two thin peaks echoing the logo's mark — used as a subtle branding
 * element rather than a full decorative landscape. Rendered as a single
 * gold hairline stroke over the section background, at low opacity by
 * default. Height, opacity and color can be overridden by consumers.
 */
export const MountainLine = ({ className = "", opacity = 0.35, stroke = "#B08D2F" }) => {
  return (
    <svg
      viewBox="0 0 1200 80"
      preserveAspectRatio="none"
      className={className}
      aria-hidden="true"
      style={{ opacity }}
    >
      {/* soft under-glow — barely visible, only present on dark backgrounds */}
      <path
        d="M0 70 L420 22 L560 44 L780 8 L960 30 L1200 62 L1200 80 L0 80 Z"
        fill="rgba(176,141,47,0.05)"
      />
      {/* the actual hairline — two subtle peaks */}
      <path
        d="M0 70 L420 22 L560 44 L780 8 L960 30 L1200 62"
        fill="none"
        stroke={stroke}
        strokeWidth="0.9"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default MountainLine;
